import React, { useEffect, useState } from 'react';
import { Sidebar } from './components/Layout/Sidebar';
import { Header } from './components/Layout/Header';
import { Login } from './pages/Auth/Login';
import { Dashboard } from './pages/Dashboard';
import { ProgramList } from './pages/Program/ProgramList';
import { ProgramCreate } from './pages/Program/ProgramCreate';
import { ProgramDetail } from './pages/Program/ProgramDetail';
import { StockList } from './pages/Warehouse/StockList';
import { CommodityList } from './pages/Warehouse/CommodityList';
import { InboundGRN } from './pages/Warehouse/InboundGRN';
import { OutboundOrder } from './pages/Warehouse/OutboundOrder';
import { OrderList } from './pages/Distribution/OrderList';
import { PODReview } from './pages/Distribution/PODReview';
import { OutletRegistry } from './pages/SPHP/OutletRegistry';
import { PriceMonitoring } from './pages/SPHP/PriceMonitoring';
import { StockReport } from './pages/Reports/StockReport';
import { AuditTrail } from './pages/Reports/AuditTrail';
import { ProcurementPlan } from './pages/Procurement/ProcurementPlan';
import { RecipientBatch } from './pages/BantuanPangan/RecipientBatch';
import { SystemConfig } from './pages/Settings/SystemConfig';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [subPage, setSubPage] = useState<string | null>(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (!isAuthenticated) {
    return <Login onLoginSuccess={() => setIsAuthenticated(true)} data-id="element-0" />;
  }
  const navigateTo = (page: string, sub?: string | null, id?: string | null) => {
    setCurrentPage(page);
    setSubPage(sub || null);
    setSelectedId(id || null);
    if (window.innerWidth < 1024) {
      setSidebarOpen(false);
    }
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentPage('dashboard');
    setSubPage(null);
    setSelectedId(null);
    setSidebarOpen(false);
  };
  const handleToggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };
  const renderContent = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard onNavigate={navigateTo} data-id="element-1" />;
      case 'programs':
        if (subPage === 'create') {
          return <ProgramCreate onCancel={() => navigateTo('programs')} onSuccess={() => navigateTo('programs')} data-id="element-2" />;
        }
        if (subPage === 'detail' && selectedId) {
          return <ProgramDetail id={selectedId} onBack={() => navigateTo('programs')} data-id="element-3" />;
        }
        return <ProgramList onCreateClick={() => navigateTo('programs', 'create')} onDetailClick={id => navigateTo('programs', 'detail', id)} data-id="element-4" />;
      case 'warehouse':
        if (subPage === 'commodities') return <CommodityList data-id="element-5" />;
        if (subPage === 'inbound') return <InboundGRN onBack={() => navigateTo('warehouse')} data-id="element-6" />;
        if (subPage === 'outbound') return <OutboundOrder onBack={() => navigateTo('warehouse')} data-id="element-7" />;
        return <StockList onInboundClick={() => navigateTo('warehouse', 'inbound')} onOutboundClick={() => navigateTo('warehouse', 'outbound')} onCommodityClick={() => navigateTo('warehouse', 'commodities')} data-id="element-8" />;
      case 'distribution':
        if (subPage === 'pod') return <PODReview onBack={() => navigateTo('distribution')} data-id="element-9" />;
        return <OrderList onPODClick={() => navigateTo('distribution', 'pod')} data-id="element-10" />;
      case 'sphp':
        if (subPage === 'monitoring') return <PriceMonitoring data-id="element-11" />;
        return <OutletRegistry onMonitoringClick={() => navigateTo('sphp', 'monitoring')} data-id="element-12" />;
      case 'reports':
        if (subPage === 'audit') return <AuditTrail data-id="element-13" />;
        return <StockReport onAuditClick={() => navigateTo('reports', 'audit')} data-id="element-14" />;
      case 'procurement':
        return <ProcurementPlan data-id="element-15" />;
      case 'bantuan':
        return <RecipientBatch data-id="element-16" />;
      case 'settings':
        return <SystemConfig data-id="element-17" />;
      default:
        return <Dashboard onNavigate={navigateTo} data-id="element-18" />;
    }
  };
  const getPageTitle = () => {
    if (currentPage === 'programs' && subPage === 'create') return 'Buat Program Baru';
    if (currentPage === 'programs' && subPage === 'detail') return 'Detail Program';
    if (currentPage === 'warehouse' && subPage === 'commodities') return 'Daftar Komoditas Pangan';
    if (currentPage === 'warehouse' && subPage === 'inbound') return 'Penerimaan Barang (GRN)';
    if (currentPage === 'warehouse' && subPage === 'outbound') return 'Pengeluaran Barang';
    if (currentPage === 'distribution' && subPage === 'pod') return 'Review POD';
    if (currentPage === 'sphp' && subPage === 'monitoring') return 'Monitoring Harga SPHP';
    if (currentPage === 'reports' && subPage === 'audit') return 'Audit Trail';
    switch (currentPage) {
      case 'dashboard':
        return 'Dasbor Nasional';
      case 'programs':
        return 'Program & Penugasan';
      case 'warehouse':
        return 'Daftar Stok Gudang';
      case 'distribution':
        return 'Order Distribusi';
      case 'sphp':
        return 'Outlet & Mitra SPHP';
      case 'reports':
        return 'Laporan Stok';
      case 'procurement':
        return 'Rencana Pengadaan';
      case 'bantuan':
        return 'Data Penerima Bantuan';
      case 'settings':
        return 'Konfigurasi Sistem';
      default:
        return 'Sistem BULOG';
    }
  };
  const getBreadcrumbs = () => {
    const crumbs = ['Beranda'];
    if (currentPage === 'dashboard') return crumbs;
    // Add main page
    const pageNames: Record<string, string> = {
      programs: 'Program',
      warehouse: 'Gudang & Stok',
      distribution: 'Distribusi',
      sphp: 'SPHP Retail',
      reports: 'Laporan',
      procurement: 'Pengadaan',
      bantuan: 'Bantuan Pangan',
      settings: 'Pengaturan'
    };
    if (pageNames[currentPage]) {
      crumbs.push(pageNames[currentPage]);
    }
    // Add sub page
    if (subPage) {
      crumbs.push(getPageTitle());
    }
    return crumbs;
  };
  return <div className="flex h-screen bg-gray-50 overflow-hidden" data-id="element-19">
      <Sidebar currentPage={currentPage} onNavigate={navigateTo} onLogout={handleLogout} isOpen={sidebarOpen} onClose={handleCloseSidebar} data-id="element-20" />

      {sidebarOpen && <div className="fixed inset-0 bg-black/60 z-30 lg:hidden" onClick={handleCloseSidebar} data-id="element-21" />}

      <div className="flex-1 flex flex-col overflow-hidden min-w-0" data-id="element-22">
        <Header title={getPageTitle()} breadcrumbs={getBreadcrumbs()} onMenuClick={handleToggleSidebar} sidebarOpen={sidebarOpen} data-id="element-23" />

        <main className="flex-1 overflow-y-auto bg-gray-50" data-id="element-24">
          <div className="max-w-[1600px] mx-auto p-4 sm:p-6 lg:p-8" data-id="element-25">
            {renderContent()}
          </div>
        </main>
      </div>
    </div>;
}